/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Filter_User_Id_PlaceholderInputs */

const en_audit_filter_user_id_placeholder = /** @type {(inputs: Audit_Filter_User_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by user ID`)
};

const pt_br2_audit_filter_user_id_placeholder = /** @type {(inputs: Audit_Filter_User_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por ID do usuário`)
};

/**
* | output |
* | --- |
* | "Filter by user ID" |
*
* @param {Audit_Filter_User_Id_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_filter_user_id_placeholder = /** @type {((inputs?: Audit_Filter_User_Id_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Filter_User_Id_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_filter_user_id_placeholder(inputs)
	return pt_br2_audit_filter_user_id_placeholder(inputs)
});